import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

const LogoutIcon = (props) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G
      clipPath="url(#a)"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={props.color}
    >
      <Path d="M15 18.75a.75.75 0 0 1-.75.75h-12a.75.75 0 0 1-.75-.75V5.25a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 .75.75v3a.75.75 0 1 0 1.5 0v-3A2.25 2.25 0 0 0 14.25 3h-12A2.25 2.25 0 0 0 0 5.25v13.5A2.25 2.25 0 0 0 2.25 21h12a2.25 2.25 0 0 0 2.25-2.25v-3a.75.75 0 1 0-1.5 0v3Z" />
      <Path d="M23.781 12.531a.751.751 0 0 0 0-1.062l-4.5-4.5a.75.75 0 1 0-1.062 1.062l3.22 3.219H8.25a.75.75 0 1 0 0 1.5h13.19l-3.221 3.219a.75.75 0 0 0 1.062 1.062l4.5-4.5Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill={props.color} d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);

LogoutIcon.defaultProps = {
  color: "#fff",
};
export default LogoutIcon;
